import {sx} from './sx'
import {Box, Stack} from "@mui/material";
import DownloadExport from "@ui/tableCustom/containers/export/downloadExport/DownloadExport";
import ToggleExportMode from "@containers/export/containers/buildData/view/buttons/toggleExportMode/ToggleExportMode";
import SideBarChangeExport from "@containers/export/containers/buildData/view/sidebar/SideBarChangeExport";
import FileName from "@ui/tableCustom/containers/export/fileName/FileName";
import ToggleScreenModeButton from "@ui/modal/buttons/toggleScreenModeButton/ToggleScreenModeButton";
import SettingsBar from "@ui/tableCustom/view/settingsBar/SettingsBar";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {
    GenerateExportExcelHeadColumnStylesCb,
    GenerateExportExcelRowStylesCb,
    HeadColumns,
    IBaseExportStyles,
    IChangeExportSidebarSettings,
    RowData
} from "@ui/tableCustom/types/table";
import {ReactNode} from 'react';
import {SetStatePropsType} from "@baseTypes/base";
import {ExportPdfContent} from "@containers/export/containers/pdf/types";
import {MenuSettingsChildren} from "@ui/menuBarCustom/types";

interface IProps<T> {
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    params: IQueryParamsContext<T>,
    exportParams: IExportParamsContext<T>,
    exportMutate: IExportMutateContext<T>,
    disabled?: boolean,
    hasExport?: boolean,
    hasPdfExport?: boolean,
    sidebar?: ReactNode,
    baseExportStyles?: IBaseExportStyles<T>,
    fullScreenMode: boolean,
    setFullScreenMode: SetStatePropsType<boolean>,
    hasModalFullScreen?: boolean,
    stickyHeader: boolean,
    setStickyHeader: SetStatePropsType<boolean>
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb,
    changeExportSidebarSettings?: IChangeExportSidebarSettings,
    allData?: RowData<T>[],
    hasExportDataFromAllPage?: boolean
    headerExportContents?: {
        pdf?: ExportPdfContent,
        excel?: any
    },
    menuSettingsTable?: MenuSettingsChildren
}

function TableCustomRootSideBar<T>({
                                       fullColumns,
                                       headColumns,
                                       params,
                                       exportParams,
                                       exportMutate,
                                       disabled,
                                       hasExport,
                                       hasPdfExport,
                                       sidebar,
                                       baseExportStyles,
                                       allData,
                                       hasExportDataFromAllPage = false,
                                       headerExportContents,
                                       fullScreenMode,
                                       setFullScreenMode,
                                       stickyHeader,
                                       setStickyHeader,
                                       generateExportExcelRowStylesCb,
                                       generateExportExcelHeadColumnStylesCb,
                                       changeExportSidebarSettings,
                                       menuSettingsTable,
                                       hasModalFullScreen = true
                                   }: IProps<T>) {

    const {exportMode} = exportParams;

    return (
        <Stack
            gap={'10px'}
            sx={{
                width: exportMode ? '100%' : 'auto'
            }}
        >
            <Box sx={sx.wrapper}>

                {sidebar && sidebar}

                {hasExport && <>
                    {exportMode && <DownloadExport
                        params={params}
                        fullColumns={fullColumns}
                        headColumns={headColumns}
                        exportParams={exportParams}
                        exportMutate={exportMutate}
                        baseExportStyles={baseExportStyles}
                        allData={allData}
                        headerExportContents={headerExportContents}
                        generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
                        generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
                        hasPdfExport={hasPdfExport}
                    />}

                    <ToggleExportMode
                        exportParams={exportParams}
                        disabled={disabled}
                    />
                </>}

                <SettingsBar
                    stickyHeader={stickyHeader}
                    setStickyHeader={setStickyHeader}
                    disabled={disabled}
                    menuSettingsTable={menuSettingsTable}

                />

                {hasModalFullScreen && <ToggleScreenModeButton
                    fullScreenMode={fullScreenMode}
                    setFullScreenMode={setFullScreenMode}
                />}

            </Box>

            {exportMode && <SideBarChangeExport
                hasExportDataFromAllPage={hasExportDataFromAllPage}
                exportParams={exportParams}
                exportMutate={exportMutate}
                changeExportSidebarSettings={changeExportSidebarSettings}
            />}
            {exportMode && <FileName exportParams={exportParams}/>}
        </Stack>
    );
};

export default TableCustomRootSideBar;